import Authorization from "../components/auth/authorization";
import { initializeIcons } from "@fluentui/react";
import { UserPermission } from "../constants/permissions.constants";
import { useContainerStyles } from "../@styles/container.styles";
import UpdateActivationKeyStatusPage from "../components/activationkey-cn update/updateactivationkey";

const AllActivationkeyPage = () => {
  const contClasses = useContainerStyles();
  initializeIcons();
  return (
    <Authorization>
      <section
        key={UserPermission.P_ACTIVATION_KEY_CN}
        className={contClasses.sectionContainer}
      >
        <div className={"dashboard-tile " + contClasses.boxContainer}>
          <div className={contClasses.root}>
            <div style={{ marginTop: "3rem" }}>
              <div style={{ paddingLeft: "1rem", width: "90%" }}></div>
              <UpdateActivationKeyStatusPage />
            </div>
          </div>
        </div>
      </section>
    </Authorization>
  );
};

export default AllActivationkeyPage;
